import styled from 'styled-components';
import { palette } from 'styled-tools';

export const Icon = styled.span`
  color: ${palette('colorBody')};
  display: flex;
  place-content: center;
  place-items: center;
  justify-content: center;
  padding: 6px 0;
  margin-left: 4px;
`;

export const WorkspaceToolbar = styled.div`
  display: flex;
  place-content: space-between;
  place-items: center;
  align-items: center;
  justify-items: center;
  margin-bottom: 14px;
  gap: 10px;
`;

export const ToolbarRight = styled.div`
  display: flex;
  place-content: space-between;
  place-items: center;
  align-items: center;
  gap: 5px;
`;
